import { PlanLimitConfigs, BillingCycleConfig } from "../types.ts";

export const SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const SERVICE_COLLECTION_DEFAULT_UNIT_COUNT = 75;

export const SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT = 201;

export const serviceCollectionOfferingSkus = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
} as const;

export const serviceCollectionOfferingSkusArray = Object.values(
    serviceCollectionOfferingSkus
);

export const serviceCollectionPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: serviceCollectionOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 20_000
    },
    {
        planName: "Standard",
        offeringSku: serviceCollectionOfferingSkus.standard,
        recommendationLimit: 3,
        signupLimit: 20_000
    },
    {
        planName: "Premium",
        offeringSku: serviceCollectionOfferingSkus.premium,
        recommendationLimit: 50,
        signupLimit: 20_000
    },
    {
        planName: "Enterprise",
        offeringSku: serviceCollectionOfferingSkus.enterprise,
        recommendationLimit: 250,
        signupLimit: 20_000,
        minUnitCount: SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT
    }
];

export const serviceCollectionBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
